import React from "react";
import Box from "@mui/material/Box";
import {getAuthorizeURL} from "../fn";
import {Link1} from "../domains/common/components/Typography";

export default function MainPage() {
  return (
    <Box display="flex" height={200}>
      <Box m="auto" sx={{textAlign: 'center'}}>
        Сервис электронной регистрации сделки
        <p/>
        <Link1 href={getAuthorizeURL()}>Войти</Link1>
      </Box>
    </Box>)
}
